import Block1Background from './block1-background-alt.jpg'
import Block3Background from './fruit-bar-tray1.jpg'

let GridBlocksData = [
  {
    header: true,
    image: Block1Background,
    imageAlt: 'Background',
    text: ''
  },
  {
    image: '',
    imageAlt: 'Coconut',
    text:
      'A passion for culinary exploration led us into the exquisite and beautiful world of fruits and creamy flavors. With relentless attention to quality, we created Solero, a frozen treat elevated by its refreshing texture and perfectly blended ingredients. Solero is like no other – natural and authentic, from the way it’s made to the way it looks and tastes.'
  },
  {
    image: Block3Background,
    imageAlt: 'Limes'
  },
  {
    image: '',
    imageAlt: 'Lemon-Lime',
    text: 'Because we love fruit so much, our fruit bars and pops are made with natural or organic ingredients.'
  }
]

export default GridBlocksData



// WEBPACK FOOTER //
// ./src/views/home/GridBlocksData.js